import { api } from "./httpClient";

export const errorLogService = {
  logError(payload) {
    return api("/v1/error-logs", { method: "POST", body: payload });
  },
};
